/**
 * componente che sostituisce il UploadPhotoRefactored.jsx
 * per fare la pagina di upload delle immagini delle figurine
 * 
 */

import React from "react";
import {inject, observer} from "mobx-react";

import Indicazioni from '../../assets/img/sa/indicazioni.png'

import {toJS} from "mobx";
import Select from "material-ui/Select/Select";
import MenuItem from "material-ui/Menu/MenuItem";

import LogoUser from "../../layouts/Users/LogoUser";
import PhotoselfieIstruction from "../../layouts/Users/PhotoselfieIstruction";

// sostituisce ImageUpload  e fa l'upload sul server API delle immagini appena le si sceglie
import PhotoUpload from "../../components/CustomUpload/PhotoUpload";
// import PhotoUpload2 from "../../components/CustomUpload/PhotoUpload2";

import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";

import Button from "../../components/CustomButtons/Button";

import Snackbar from '../../components/Snackbar/Snackbar';
import AddPhoto from "@material-ui/icons/AddAPhoto";

import terms_conditions_privacy_policy_IT from '../../assets/pdfs/terms_conditions_privacy_policy_IT.pdf';
import terms_conditions_privacy_policy_EN from '../../assets/pdfs/terms_conditions_privacy_policy_EN.pdf';
import terms_conditions_privacy_policy_DE from '../../assets/pdfs/terms_conditions_privacy_policy_DE.pdf';
import terms_conditions_privacy_policy_ES from '../../assets/pdfs/terms_conditions_privacy_policy_ES.pdf';
import terms_conditions_privacy_policy_FR from '../../assets/pdfs/terms_conditions_privacy_policy_FR.pdf';

import {
    PHOTOSELFIE_BASE_URL,
} from "../../utils/constants";

import '../../assets/css/utenti.css';
import '../../assets/css/configuration.css';
import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid from "../../components/Grid/ItemGrid";
import {Card} from "material-ui";






@inject('store') // include /src/store/store.js che a sua volta include /src/store/AppState.js
@observer

class UploadPhotoMultiRefactored extends React.Component {

    constructor(props) {

        super(props);
        this.store = this.props.store.appState;

        

        this.state = {
            ProjectID: 0,
            utentname: '',
            utentlastname: '',
            email: '',
            confirmed_email: '',
            language: 'it',
            team: '',
            category: '',
            namelastname: '',
            categoryReferent: false,
            termini_condizioni: false,
            termini_condizioni_mail: false,
            errors: {},
            formIsValid: false,
            ProjectType: '',
            projectData: [],
            simpleProject: false,
            url_ok: false,

            showUploadError: false,
            tc: false,
            
            showErrorWarning: false,
            msgErrorWarning: '',
            openErrorWarning: false,

            NPUW_open : false, // flag per il dialog di alert per immagini non per tutti
           
            setTC: false,
            landing_page_enabled: true,
            showReferentCheckbox: true,
            athleteData: {
                name: '',   // Nome
                lastname: '', // Cognome
                team: null,
                category: null,
                photo: null,
                is_referent: false,
                referent_mail: '',
                ProjectID: null,
                photoID: null,
                name_lastname: null,
                teamID: null,
                categoryID: null
            },
            athleteList: [],    // lista degli atleti che seleziono per caricare le photo
            uniqueAthletes: [], // lista di tutti gli atleti per categoria e team selezionati
            photoUpload : false,
            selectedCategory: null,
            selectedTeam: null,
            selectedTeamDisabled: false,
            selectedAthlete: null,
            uploaded: true,     // se true il pulsante "salva" è disabilitato
            team_passed_from_url: '',
            url_with_team: true,
        };

        // struttura dei dati per ogni atleta che salvo nella .state.athleteList
        // che poi passo singolarmente al PhotoUpload
        this.athlete = {
            name: '',   // Nome
            lastname: '', // Cognome
            team: null,
            category: null,
            photo: null,
            is_referent: false,
            referent_mail: '',
            ProjectID: null,
            photoID: null,
            name_lastname: null,
            teamID: null,
            categoryID: null,
            PhotoUploaded: '',
            ProjectType: '',
            TeamName: '',
            CategoryName: '',
            NomeCognome: '',
        };


    }

    

    /**
     * fa la chiamata a store.get_landing_page_data_by_url
     * per ottenere via API la lista dei nominativi con relative squadre e categorie
     * che sono poi usate per popolare le select per caricare le foto
     * 
     */
    componentWillMount() {

        const self = this;
        let urlPath = self.props.history.location.pathname;

        self.store.photo_uploaded.clear();

        if (urlPath.length < 1) {
            self.setState({url_ok: false});
            return;

        } else if (urlPath.length < 0 || urlPath === '/upload-photo' || urlPath === '/upload-photo/') {
            
            self.setState({url_ok: false});
            return;

        } else {

            // la url della pagina aperta
            let fullUrl = PHOTOSELFIE_BASE_URL + urlPath;
            
            if (fullUrl.endsWith("/")){
                fullUrl = fullUrl.substring(0, fullUrl.length - 1);
            }

            // conto quanti "/" ci sono: se sono 5 allora sono nel caso di url per squadra
            const number = (fullUrl.match(/\//g) || []).length;

            let finalUrl = fullUrl;
            let team_from_url = '';
                
            if(number === 5){

                // sono nel caso delle url per le singole squadre

                // 1- get team name from url
                team_from_url = fullUrl.substring(fullUrl.lastIndexOf('/') + 1);                
                const url_without_team = fullUrl.substring(0, fullUrl.lastIndexOf('/'));                
                finalUrl = url_without_team;

                self.setState({team_passed_from_url: team_from_url});
            }

            // workaroud perchè altrimneti non trova i riferimenti a db
            // perchè il link ufficiale (per adesso) è solo quello con 'upload-photo'            
            let newFinalUrl = finalUrl.replace('upload-photo-multi','upload-photo');
            
            // fa la chiamata API per avere la lista di tutti i nomintaivi con la squadra e la categoria
            self.store.get_landing_page_data_by_url(newFinalUrl, function (res) {
                    
                // se avevo gia indicato il team, fisso la select del team con il valore indicato
                if(team_from_url.length > 0) {

                    const projectData = res;
                    
                    // let uniqueCategories = [...new Map(projectData.map(item => [item['CategoryName'], Object.assign({id: item.CategoryID,name: item.CategoryName})])).values()];
                    let uniqueTeams = [...new Map(projectData.map(item => [item['TeamName'], Object.assign({id: item.TeamID, name: item.TeamName})])).values()];
                    
                    let teamFound = false;

                    res.forEach((athlete) => {
                        const team = athlete.TeamName.replace(/\s/g, "_").toLowerCase();
                        if (team === team_from_url) {
                            uniqueTeams.forEach((team) => {
                                const teamName = team.name.replace(/\s/g, "_").toLowerCase();
                                if (teamName === team_from_url) {
                                    self.setState({selectedTeam: team});
                                    teamFound = true;
                                }
                            });
                        }
                    });

                    if(self.state.selectedTeam !== null){
                        self.selectTeamFromUrl(self.state.selectedTeam);
                    }

                    if (!teamFound) {
                        self.setState({url_with_team: false});
                    }
                }


                if (res) {

                    self.store.handle_app_lang(res[0].Language);

                    if (res[0].send_excel_to_ref === 0) {
                        self.setState({
                            showReferentCheckbox: false
                        });
                    }

                    self.setState({
                        language: res[0].Language,
                        ProjectType: res[0].ProjectType,
                        ProjectID: res[0].ProjectID,
                        projectData: res,
                        url_ok: true
                    });

                    if (res[0].landing_page_enabled === 0) {
                        self.setState({
                            landing_page_enabled: false
                        })
                    }
                }

            });
        }
        
    }

    componentDidMount() {
        document.body.style.background = '#235F84';
    }


    /**
     * evento onChange sul selettore della squadra
     * salva il valore nella this.state.selectedTeam 
     * e nei dati di this.state.athleteData
     * 
     * @param {*} event 
     */
    selectTeam = (event) => {

        const val = event.target.value;

        this.setState((prevState) => ({
            ...prevState,
            selectedTeam: val,
            selectedCategory: null,
            selectedAthlete: null,
            athleteData: {
                ...prevState.athleteData,
                team: val.name,
                teamID: val.id,
                name: '',
                lastname: '',
                category: null,
                categoryID: null
            },
            errors: {
                ...prevState.errors,
                team: ''
            }
        }))

        this.clearUploadArea();

    };


    /**
     * evento onChnage sul selettore della categoria
     * salva il valore nella this.state.selectedCategory e nei dati di this.state.athleteData
     * 
     * @param {*} event 
     */
    selectCategory = (event) => {

        const val = event.target.value;

        this.setState((prevState) => ({
            ...prevState,
            selectedCategory: event.target.value,
            athleteData: {
                ...prevState.athleteData,
                category: val.name,
                categoryID: val.id,
                name: '',
                lastname: '',
                name_lastname: null,
                photoID: null
            },
            errors: {...this.state.errors, category: ''},
            selectedAthlete: null
        }));

        this.clearUploadArea();
    };

    /**
     * preseleziona la squadra se p indicta nella url con il parametro team
     * richiamato da this.componentWillMount
     * 
     * @param {*} team 
     */
    selectTeamFromUrl = (team) => {
        
        this.setState((prevState) => ({
            ...prevState,
            selectedTeam: team,
            selectedTeamDisabled: true,
            selectedCategory: null,
            selectedAthlete: null,
            athleteData: {
                ...prevState.athleteData,
                team: team.name,
                teamID: team.id,
                name: '',
                lastname: '',
                category: null,
                categoryID: null
            },
            errors: {
                ...prevState.errors,
                team: ''
            }
        }));

        // this.clearUploadArea();

    };


    /**
     * evento onChange sul selettore dell'atleta
     * aggiungo ad this.state.athleteList l'elemento selezionato
     * se è stata scelta l'opzione tutti, allora recupera la lista di tutti gli atleti e li aggiunge
     * 
     * @param {*} event 
     */
    selectNameLastname = (event) => {

        // i val del selector sono gli oggetti di this.state.athleteData
        const val = event.target.value;
        const { athleteList } = this.state;

       
        if(val.photoID === '' ){
            // selezionare tutti gli atleti

            // const { uniqueAthletes, uniqueCategories } = this.getUniqueAthletes();
            const { uniqueAthletes } = this.getUniqueAthletes();
            
            // ciclo la lista completa
            uniqueAthletes.forEach( (athlete) => {
                // e se non già in lista, aggiungo l'atleta, escludo l'elemento senza photoID
                if( !athleteList.some( (item) => { return (item.photoID === athlete.photoID ) }) && parseInt(athlete.photoID, 10) ){
                    athleteList.push(athlete);
                    
                }

            });

        } else {

            // aggiungo solo l'atleta selezionato, se non è già presente
            if( !athleteList.some( (item) => { return item.photoID === val.photoID})){
                athleteList.unshift(val);
            }
            
        }

        this.setState((prevState) => ({
            ...prevState,
            selectedAthlete: val,
            athleteList: athleteList,
            uploaded: false,
            photoUpload: true,
            errors: {
                ...prevState.errors,
                name: '',
                lastname: ''
            }
        }))

       
    };

    

    
    /**
     * controlli sui dati del form prima dell'invioù
     * @returns 
     */
    handleFormValidation = () => {

        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        // const {athleteData, athleteList, termini_condizioni, ProjectType, team_passed_from_url} = this.state;
        const {athleteData, termini_condizioni, ProjectType, team_passed_from_url} = this.state;

        let errors = {};
        let formIsValid = true;
        
        // team , category , terms_and_conditions
        if (ProjectType === 'C') {
            if (!athleteData.team) {
                errors['team'] = 'Select team *'
                formIsValid = false
            }
        }

        if(!team_passed_from_url.length > 0 && ProjectType === 'C') {
            if (!athleteData.team) {
                errors['team'] = 'Select team *'
                formIsValid = false
            }
        }

        // il check delle condizioni e termini d'uso
        if (!termini_condizioni) {
            errors['terms'] = 'I accept terms & conditions *'
            formIsValid = false
            this.gridErrorWarning(DEFAULT_TEXT.no_terms_condition);
        }


        if (formIsValid && this.store.photo_uploaded.length <= 0) {
            errors['photo_uploaded'] = true;
            formIsValid = false;
            this.gridErrorWarning(DEFAULT_TEXT.no_photo_uploaded);
        }

        
        this.setState({errors: errors, formIsValid: formIsValid});

        return formIsValid;
    }


    /**
     * apre il dialog di avviso mancanza di foto
     * ovvero che ci sono meno foto di atleti selezionati
     * 
     */
    checkNumeberPhotoUploaded =  () => {

        // apro il dialog
        this.setState({NPUW_open: true});
       
    }


    /**
     * evento chiusura dialog di avviso mancanza di foto 
     * se button == true (click su ok) passa alla funzione per l'invio dei dati
     * negli atri casi invece chiude ildialog e non fa altro
     * 
     * @param {*} button 
     */
    handleCloseNumberPhotoUpload =  (button) => {

        this.setState({NPUW_open: false});

        if(button=== true){
            this.sendAthleteData();
        }
        
    }
    

    /**
     * evento click sul pulsanti di "INVIA" 
     * controlla i dati del form, poi se ci sono tutte le foto per tutti gli atleti
     * se si prosegue con l'ivio dei dati, se no apre il dialog di avviso
     * 
     */
    saveAthleteData = () => {

        if (this.handleFormValidation()) {

            const { athleteList } = this.state;
            // controllo se il numeor di photo upload è uguale al numero di atleti in lista (selezionati)
            if( this.store.photo_uploaded.length !== athleteList.length ){
                // no, è diverso quindi apri popup per chiedere cosa fare
                this.checkNumeberPhotoUploaded();
            } else {
                // si sono uguali, allora prosegui
                this.sendAthleteData();
            }
        }

    }


    /**
     * invia i dati del form alle API
     * fa ancora un controllo sui dati
     * e poi prepara i dati per l'ivio e infine richiama la funzione save_multi_athlete_data di src\stores\AppState.js
     * 
     */
    sendAthleteData = () => {

        const {athleteData, ProjectID } = this.state;
        const self = this;

        // verifica se i dati sono validi e poi 
        if (this.handleFormValidation()) {

            self.setState({uploaded: true});

            const data = {} ;
            data.is_referent = athleteData.is_referent ? 0 : Number(athleteData.is_referent)
            data.referent_mail = athleteData.referent_mail ? 0 : Number(athleteData.referent_mail); // ??
            data.ProjectID = ProjectID;

            // lista di tutti gli atleti selezionati con i loro dati
            data.photo_uploaded = toJS(this.store.photo_uploaded);
            data.number_athletes = this.store.photo_uploaded.length;
            
            // fa la chiamata APi alla url '/photoselfie/save_athlete_data/' passandogli i dati del form
            this.store.save_multi_athlete_data(data, function (res) {

                if (res.success === true) {
                    
                    const emailReferente = res.email_referente ? res.email_referente : "";

                    // se risponde con la emailReferente richiama il giro per la newslettere
                    if (emailReferente === "") {
                        // tutto ok, vado alla pagina finale
                        self.props.history.push('/confirm-upload-photo');
                        self.store.file = null;
                    } else {
                        self.registerToNewsletter(athleteData, emailReferente);
                    }

                } else {
                    // qualcosa è andato storto resto in pagina
                    self.showNotification("tc");
                    self.setState({uploaded: false});
                }

            });
           
        }

    }
    
    
    /**
     * 
     * @param {*} athleteData 
     * @param {*} emailReferente 
     */
    registerToNewsletter = (athleteData, emailReferente) => {
        const self = this;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        let params = {
            'email': emailReferente,
            newsletter_hello: DEFAULT_TEXT.hello,
            newsletter_text_email_1: DEFAULT_TEXT.newsletter_text_email_1,
            newsletter_text_email_2: DEFAULT_TEXT.newsletter_text_email_2,
            newsletter_text_email_3: DEFAULT_TEXT.newsletter_text_email_3,
            newsletter_text_email_4: DEFAULT_TEXT.newsletter_text_email_4,
            newsletter_text_email_5: DEFAULT_TEXT.newsletter_text_email_5,
            newsletter_thank: DEFAULT_TEXT.newsletter_thank,
            project_id: athleteData.ProjectID,
            'source': 'photoselfie',
            newsletter_unsubscribe_text: DEFAULT_TEXT.newsletter_unsubscribe_text,
            newsletter_unsubscribe_btn: DEFAULT_TEXT.newsletter_unsubscribe_btn,
            newsletter_unsubscribe_text_one: DEFAULT_TEXT.newsletter_unsubscribe_text_one,
        };

        self.store.check_newsletter_registration(params);
        self.props.history.push('/confirm-upload-photo');
        self.store.file = null;
    }



    /**
     * alert generale che poi fa ricaricare la pagina
     * chiude il dialog e ricarica la pagina, azzerando il form
     */
    closeAndReloadPage = () => {
        this.setState({setTC: false, tc: false});
        window.location.reload();
    }

    /**
     * apre il dialog di avviso di alert generale
     * 
     * @param {*} place 
     */
    showNotification = (place) => {
        switch (place) {
            case "tc":
                if (!this.state.tc) {
                    this.setState({showUploadError: true, tc: true});
                }
                break;
            default:
                break;
        }
    };

    
    /**
     * toast message for error warning
     * chiude l'avviso
     */
    closeErrorWarning = () => {
        this.setState({openErrorWarning: false});
    }

    /**
     * toast message for error warning
     * apre l'avviso
     * @param {*} msg 
     */
    gridErrorWarning = (msg) => {
        if (!this.state.openErrorWarning) {
            this.setState({
                showErrorWarning: true, 
                msgErrorWarning: msg, 
                openErrorWarning: true
            });
        }
    };



    // quando digito nei due campi input text di nome e cognome
    /**
     * evento onChange sui campi di input di nome e cognome
     * salvo il valore digitato nei campi this.athele.name o this.atlete.lastname
     * 
     * @param {*} e 
     */
    handleInputOnChangeNameLastname = (e) => {

        const name = e.target.name;
        const val = e.target.value;

        const athlete = this.athlete;

        if(name==='athleteName') {
            
            athlete.name = val;

        } else if(name==='athleteLastname') {
            athlete.lastname = val;
        }

        this.setState((prevState) => ({
            ...prevState,
            errors: {
                ...prevState.errors,
                name: '',
                lastname: ''
            }
        }))

        
    }

    /**
     * evento onBlur sui campi input di nome e cognome
     * quando esco dai campi controllo lo stato dei due valori e se sono entrambi compilati aggiungo
     * un nuovo elemento per caricare le foto dell'atleta inserito
     * 
     * @param {*} e 
     */
    handleInputOnBlurNameLastname = (e) => {

        const { athleteList} = this.state;
        const athlete = this.athlete;
        
        // aggiungo alla lista degli athleti slezionati un nuovo elemento che non è ancora salvato in db
        // e quindi ha photoID negativo
        let photo_id = -1;

        while ( athleteList.some( (item) => { return item.photoID === photo_id}) ) {
            // potrei avere più elementi nuovi, e ognuno deve avere un id diverso
            photo_id--
        }

        if( athlete.name.length>0 && athlete.lastname.length>0){
            
            const {selectedCategory, selectedTeam, ProjectID, ProjectType, projectData  } = this.state;

            // un nuovo elemento con la struttura di state.athlete
            const nuovo = {};
            nuovo.photoID = photo_id;
            nuovo.name = athlete.name;
            nuovo.lastname = athlete.lastname;
            nuovo.NomeCognome = athlete.name+' '+athlete.lastname;
            nuovo.PhotoUploaded = 0;
            nuovo.ProjectID = ProjectID;
            nuovo.ProjectType = ProjectType;

            // leggo la categoria selezionata                
            if(selectedCategory){
                nuovo.categoryID = selectedCategory.id;
                nuovo.CategoryName = selectedCategory.name;
            }

            // cerco un atleta con la stessa categoria selezionata
            let anotherAthlete = projectData.find( (athlete) => {
                return athlete.CategoryID == nuovo.categoryID
            });
                
            // letto il team selezioanto
            if(selectedTeam){
                nuovo.teamID = selectedTeam.id;
                nuovo.TeamName = selectedTeam.name;
            } else if(anotherAthlete){
                // se non c'è allora uso il teamID dell'atleta della stessa categoria
                nuovo.teamID = anotherAthlete.TeamID;
                nuovo.TeamName = anotherAthlete.TeamName;
            } else {
                // alla peggio prendo il teamID del primo atleta 
                nuovo.teamID = projectData[0].TeamID                
            }

            // aggiungo l'atleta alla lista
            if( !athleteList.some( (item) => { return item.photoID === nuovo.photoID})){
                athleteList.unshift(nuovo);
            }

            this.setState((prevState) => ({
                ...prevState,
                photoUpload: true,
                uploaded: false,
                athleteList: athleteList,
                errors: {
                    ...prevState.errors,
                    lastname: ''
                }
            }))

            //resetto i dati per i altri elementi
            athlete.name = '';
            athlete.lastname = '';
        }

    }


    /**
     * restituisce la lista senza ripetizioni 
     * per la select categoria e la select degli atleti
     * 
     * @returns 
     */
    getUniqueAthletes = () => {

        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        const {
            ProjectType,
            projectData,
            athleteData
        } = this.state;

        let filtered_categories;
        let uniqueCategories;
        let filteredAthletes;

        if (ProjectType === 'C') {

            filtered_categories = projectData.filter(obj => obj.TeamName === athleteData.team);

            uniqueCategories = [...new Map(filtered_categories.map(item =>
                [item['CategoryName'],
                    Object.assign({
                        id: item.CategoryID,
                        name: item.CategoryName
                    })])).values()];

            filteredAthletes = projectData.filter(obj => obj.TeamName === athleteData.team && obj.CategoryName === athleteData.category && obj.NomeCognome !== null);

        } else {

            filteredAthletes = projectData.filter(obj => obj.CategoryName === athleteData.category && obj.NomeCognome !== null);

            uniqueCategories = [...new Map(projectData.map(item =>
                [item['CategoryName'], Object.assign({id: item.CategoryID, name: item.CategoryName})])).values()];

        }

        let uniqueAthletes = [...new Map(filteredAthletes.map(item =>
            [item['NomeCognome'], Object.assign({
                photoID: item.PhotoID,
                PhotoUploaded: item.PhotoUploaded,
                ProjectID: item.ProjectID,
                ProjectType: item.ProjectType,
                TeamName: item.TeamName,
                CategoryName: item.CategoryName,
                name: item.Nome,
                lastname: item.Cognome,
                NomeCognome: item.NomeCognome,
                categoryID: item.categoryID,
                teamID: item.teamID,
                })
            ])).values()
        ];

        // la lista uniqueAthletes serve per costruire la select
        // aggiunge all'inizio l'opzione per selezionare tutti i nominativi
        if(uniqueAthletes.length !== 0){

            const tutti = {
                NomeCognome: DEFAULT_TEXT.select_all.toUpperCase(),
                name: DEFAULT_TEXT.select_all.toUpperCase(),
                lastname: '',
                PhotoUploaded: 0,
                PhotoID: '',
                photoID: ''
            };
            const copy = Object.assign(tutti);

            uniqueAthletes.unshift(copy);
        }

        return { uniqueAthletes, uniqueCategories }

    }

    /**
     * ripulisce l'area di upload e 
     * resetta eventuali dati di atleti già caricati
     * 
     */
    clearUploadArea = () => {

        this.store.photo_uploaded.clear();

        this.setState((prevState) => ({
            ...prevState,        
            athleteList: []
            })
        );


    }


    render() {
        
        // const self = this;
        const {
            uploaded,
            athleteData,
            athleteList,
            selectedTeam,
            selectedTeamDisabled,
            selectedCategory,
            selectedAthlete,
            projectData,
            ProjectType,
            url_ok,
            showUploadError,
            termini_condizioni,
            namelastname,
            
            errors,
            tc,
            
            landing_page_enabled,
            showReferentCheckbox,
            url_with_team,
            
            showErrorWarning,
            msgErrorWarning,
            openErrorWarning,

            NPUW_open

        } = this.state;

        const athlete = this.athlete;

        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        let selecttext = '';
        if (DEFAULT_TEXT.select_button !== undefined) {
            selecttext = DEFAULT_TEXT.select_button.toUpperCase();
        }

        // testo per il botton edi invio
        let send_button = '';
        if (DEFAULT_TEXT.send_button !== undefined) {
            send_button = DEFAULT_TEXT.send_button.toUpperCase();
        }

        const { uniqueAthletes, uniqueCategories } = this.getUniqueAthletes();
        let showAthletesSelect = uniqueAthletes.length !== 0;

        let uniqueTeams = [...new Map(projectData.map(item =>
            [item['TeamName'], Object.assign({
                name: item.TeamName,
                id: item.TeamID
            })])).values()]

        
        const textIstruction = {
            album: DEFAULT_TEXT.album,
            utent_subtitle: DEFAULT_TEXT.utent_subtitle,
            instruction: DEFAULT_TEXT.instruction,
            utent_instruction_nr1: DEFAULT_TEXT.utent_instruction_nr1,
            utent_instruction_nr2: DEFAULT_TEXT.utent_instruction_nr2,
            utent_instruction_nr3: DEFAULT_TEXT.utent_instruction_nr3,
            utent_instruction_nr4: DEFAULT_TEXT.utent_instruction_nr4,
            utent_instruction_nr41: DEFAULT_TEXT.utent_instruction_nr41,
            utent_instruction_NB: DEFAULT_TEXT.utent_instruction_NB
        }

        return (

            <div>                
                { url_ok && url_with_team && (
                    <div className='main-div'>
                        
                        <LogoUser />

                        <div className='wrapper-div'>
                                
                            <PhotoselfieIstruction 
                                landing_page_enabled = {landing_page_enabled}
                                album={DEFAULT_TEXT.album}
                                textIstruction = {textIstruction}
                            />

                            {landing_page_enabled && (
                                    
                                <div className='form-input'>
                                    <hr className='horizontal-line'/>
                                    <img className='img-photoselfie' style={{marginTop: '3rem'}} src={Indicazioni} alt="Indicazioni"/>

                                    <form>
                                        <div className='flexbox'>

                                            {ProjectType === 'C' && (
                                                <div className='flexbox-row'>
                                                    <label
                                                        className={errors["team"] ? 'label-red fontRoboto' : 'label fontRoboto'}>{DEFAULT_TEXT.select_team}
                                                        <span style={{color: "red", marginLeft: '0.2rem'}}>*</span>
                                                    </label>

                                                    <div className='wrapper-select'>
                                                        <Select
                                                            displayEmpty
                                                            // className={selectedTeam !== null ? 'multiselect-disabilita' : '' }
                                                            // disabled={selectedTeam !== null ? true : false}
                                                            className={selectedTeamDisabled === true ? 'multiselect-disabilita' : '' }
                                                            disabled={selectedTeamDisabled}// !== null ? true : false}
                                                            
                                                            renderValue={
                                                                selectedTeam !== null 
                                                                    ? () => <p className={'select-para'}>{selectedTeam.name}</p>
                                                                    : () => <p className={'select-para'}>{selecttext}</p>
                                                            }
                                                            fullWidth={true}
                                                            style={{color: 'white'}}
                                                            disableUnderline={true}
                                                            value={selectedTeam !== null ? selectedTeam.id : ''}
                                                            onChange={(e) => this.selectTeam(e)}
                                                            inputProps={{
                                                                name: "simpleSelect",
                                                                id: "simple-select"
                                                            }}>
                                                            {uniqueTeams.map((team, key) => {
                                                                return (
                                                                    <MenuItem key={key} value={team}>
                                                                        <span className={'span-lang'}>{team.name}</span>
                                                                    </MenuItem>
                                                                )
                                                            })}
                                                        </Select>
                                                    </div>
                                                </div>
                                            )}

                                            <div className='flexbox-row'>

                                                <label className={errors["category"] ? 'label-red fontRoboto' : 'label fontRoboto'}>{DEFAULT_TEXT.select_category}
                                                    <span style={{color: "red", marginLeft: '0.2rem'}}>*</span>
                                                </label>

                                                <div className='wrapper-select'>
                                                    <Select
                                                        displayEmpty
                                                        className={selectedCategory !== null ? 'multiselect-disabilita' : '' }
                                                        renderValue={
                                                            selectedCategory !== null ? () => <p className='select-para'>{selectedCategory.name}</p>
                                                                : () => <p className='select-para'>{selecttext}</p>
                                                        }
                                                        fullWidth={true}
                                                        style={{color: 'white'}}
                                                        disableUnderline={true}
                                                        value={selectedCategory !== null ? selectedCategory.id : ''}
                                                        onChange={(e) => this.selectCategory(e)}
                                                        inputProps={{name: "simpleSelect", id: "simple-select"}}
                                                    >
                                                        {uniqueCategories.map((cat, key) => {
                                                            return (
                                                                <MenuItem key={key} value={cat}>
                                                                    <span className='span-lang'>{cat.name}</span>
                                                                </MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                </div>
                                            </div>

                                            {showAthletesSelect === true && (
                                                <div>
                                                    <div>
                                                        <hr className='horizontal-line-termini'/>
                                                    </div>

                                                    <div className='flexbox-row'>
                                                        <label className='label fontRoboto'>{DEFAULT_TEXT.select_name_lastname}</label>
                                                        <div className='wrapper-select'>
                                                            <Select
                                                                displayEmpty
                                                                renderValue={
                                                                    selectedAthlete !== null
                                                                        // ? () => <p className='select-para'>{selectedAthlete.Nome} {selectedAthlete.Cognome}</p>
                                                                        ? () => <p className='select-para'>{selectedAthlete.NomeCognome}</p>
                                                                        : () => <p className='select-para'>{selecttext}</p>
                                                                }
                                                                fullWidth={true}
                                                                style={{color: 'white'}}
                                                                disableUnderline={true}
                                                                value={selectedAthlete !== null ? selectedAthlete.photoID : ''}
                                                                onChange={(e) => this.selectNameLastname(e)}
                                                            >
                                                                {uniqueAthletes.map((athlete, key) => {
                                                                    return (
                                                                        <MenuItem key={key} value={athlete}>
                                                                            <span className={'span-lang'}>{athlete.name} {athlete.lastname} </span>
                                                                            {
                                                                                // athlete.PhotoUploaded === 1 && (<span role="img" aria-label="ok" style={{marginLeft: '0.2rem'}}>✅</span>)
                                                                                athlete.PhotoUploaded === 1 && (<span role="img" aria-label="ok" style={{marginLeft: '0.2rem', marginBottom: '8px'}}>&#x1F4F7;</span>)
                                                                                // https://www.quackit.com/character_sets/emoji/
                                                                            }
                                                                        </MenuItem>
                                                                    )
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </div>
 
                                                    <div>
                                                        <div className='after-lastname'>
                                                            <p className='paragraph fontRoboto'>{DEFAULT_TEXT.or}</p>
                                                        </div>


                                                        <div className='flexbox-row' style={{marginTop:'10px'}}>
                                                            <label
                                                                className={(!namelastname && errors["name"]) ? 'label-red fontRoboto' : 'label fontRoboto'} >
                                                                {errors["name"] ? errors["name"] : DEFAULT_TEXT.insert_name} 
                                                                { !namelastname ?
                                                                <span style={{
                                                                    color: "red",
                                                                    marginLeft: '0.2rem'
                                                                }}>*</span> : null} 
                                                            </label>

                                                            <input
                                                                type="text"
                                                                name='athleteName'
                                                                value = {athlete.name}
                                                                ref="name"
                                                                className='simple-input'
                                                                placeholder={DEFAULT_TEXT.name} style={{textAlign: "center"}}
                                                                onChange={(e) => this.handleInputOnChangeNameLastname(e)}
                                                                onBlur={(e) => this.handleInputOnBlurNameLastname(e)}                                                                
                                                            />
                                                        </div>

                                                        <div className='flexbox-row'  style={{marginTop:'10px'}}>
                                                            <label
                                                                className={(!namelastname && errors["lastname"]) ? 'label-red fontRoboto' : 'label fontRoboto'} >
                                                                {errors["lastname"] ? errors["lastname"] : DEFAULT_TEXT.insert_lastname}
                                                                {!namelastname ?
                                                                    <span style={{
                                                                        color: "red",
                                                                        marginLeft: '0.2rem'
                                                                    }}>*</span> : null}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name='athleteLastname'
                                                                value = {athlete.lastname ? athlete.lastname : ''}
                                                                ref="lastname"
                                                                className='simple-input'
                                                                placeholder={DEFAULT_TEXT.lastname}
                                                                style={{textAlign: "center"}}
                                                                onChange={(e) => this.handleInputOnChangeNameLastname(e)}
                                                                onBlur={(e) => this.handleInputOnBlurNameLastname(e)}
                                                                
                                                            />
                                                        </div>
                                                    </div>
                                                   
                                                </div>
                                            )}



                                           
                                            { showAthletesSelect === true && athleteList.length>0 && (

                                                <div>
                                                    <div>
                                                        <hr className='horizontal-line-termini'/>
                                                    </div>

                                                    <div className="flexbox">
                                                        <div className="flexbox-row">
                                                        
                                                            <div className="upload-area">
                                                                { athleteList.map( (athlete) => (
                                                                    <PhotoUpload
                                                                        key={athlete.photoID}
                                                                        photoID={athlete.photoID}
                                                                        athlete = {athlete}
                                                                        athleteName = {athlete.name}
                                                                        athleteLastname = {athlete.lastname}
                                                                        TeamID = {projectData[0].TeamID}
                                                                    />
                                                                ) )}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div>
                                                <div>
                                                    <hr className='horizontal-line-termini'/>
                                                </div>

                                                { showReferentCheckbox === true && (
                                                    <div className='config-checkbox fontRoboto' style={{marginTop: "2rem"}}>
                                                        <input
                                                            type="checkbox"
                                                            checked={athleteData.is_referent}
                                                            onChange={(e) => {
                                                                this.setState((prevState) => ({
                                                                    ...prevState,
                                                                    athleteData: {
                                                                        ...prevState.athleteData,
                                                                        is_referent: !prevState.athleteData.is_referent,
                                                                    }, errors: {
                                                                        ...prevState.errors,
                                                                        email: '',
                                                                        emailconfirm: ''
                                                                    }
                                                                }))
                                                            }}/>
                                                        <div>
                                                            <p className='para-checkbox fontRoboto'>{DEFAULT_TEXT.is_category_referent}</p>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className='config-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        checked={termini_condizioni}
                                                        onChange={(e) => {
                                                            this.setState((prevState) => ({
                                                                ...prevState,
                                                                termini_condizioni: !prevState.termini_condizioni,
                                                                errors: {
                                                                    ...prevState.errors,
                                                                    terms: ''
                                                                }
                                                            }))
                                                        }}
                                                    />
                                                    
                                                    <div 
                                                        className="para_check_label fontRoboto" >

                                                        <span className={errors['terms'] ? ' para-check-text para-check-text-red' : ' para-check-text'}>{DEFAULT_TEXT.accept_terms}</span>
                                                        <span 
                                                            onClick={() => {
                                                                this.store.lang === 'it' || this.store.lang === 'ii'
                                                                    ? window.open(terms_conditions_privacy_policy_IT, "_blank")
                                                                    : this.store.lang === 'de' || this.store.lang === 'at' || this.store.lang === 'ch'
                                                                        ? window.open(terms_conditions_privacy_policy_DE, "_blank")
                                                                        : this.store.lang === 'fr' || this.store.lang === 'ff' || this.store.lang === 'be'
                                                                            ? window.open(terms_conditions_privacy_policy_FR, "_blank")
                                                                            : this.store.lang === 'es'
                                                                                ? window.open(terms_conditions_privacy_policy_ES, "_blank")
                                                                                : window.open(terms_conditions_privacy_policy_EN, "_blank")
                                                            }}
                                                            className={(errors["termini_condizioni_mail"] && athleteData.is_referent) ? ' para-check-text-blue para-check-text-red' : ' para-check-text-blue'}
                                                            style={{
                                                                marginLeft: '5px',
                                                                cursor: 'pointer'
                                                            }}
                                                        >{DEFAULT_TEXT.accept_terms_and_conditions}</span>

                                                        <span
                                                            style={{
                                                                // fontFamily: "Helvetica Neue",
                                                                fontSize: '1rem',
                                                                fontWeight: 'bold',
                                                                color: "red",
                                                                marginLeft: '0.2rem',
                                                                paddingRight: '1.2rem'
                                                            }}
                                                        >*</span>

                                                    </div>
                                                </div>

                                                
                                                <div 
                                                    className={uploaded ? 'send-button-disabled' : 'send-button'} 
                                                    onClick={ () => {
                                                        if( !uploaded) {
                                                            this.saveAthleteData();
                                                        }
                                                    }}
                                                >
                                                    {send_button}
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>

                            )}

                        </div>
                    </div>
                )}
                

                <div>
                    <Dialog
                        open={NPUW_open}
                        onClose={() => this.handleCloseNumberPhotoUpload()}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {DEFAULT_TEXT.dialog_photo_number}
                        </DialogTitle>
                        <DialogContent>
                            <div id="alert-dialog-description">
                            <p>{DEFAULT_TEXT.dialog_photo_number_msg_1}</p>
                            <p><b>{DEFAULT_TEXT.dialog_photo_number_msg_2}</b></p>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.handleCloseNumberPhotoUpload(false)} autoFocus>{DEFAULT_TEXT.ps_btn_cancel }</Button>
                            <Button onClick={() => this.handleCloseNumberPhotoUpload(true)}>{DEFAULT_TEXT.btn_ok}</Button>
                        </DialogActions>
                    </Dialog>
                </div>


                {showUploadError && (
                    <GridContainer>
                        <ItemGrid xs={12} sm={12} md={12}>
                            <Card>
                                <div>
                                    <GridContainer justify="center">
                                        <ItemGrid xs={12} sm={12} md={3}>
                                            <Snackbar
                                                place="tc"
                                                color="danger"
                                                icon={AddPhoto}
                                                message={DEFAULT_TEXT.uploadFailed}
                                                open={tc}
                                                closeNotification={() => this.closeAndReloadPage()}
                                                close
                                            />
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                            </Card>
                        </ItemGrid>
                    </GridContainer>
                )}

                {showErrorWarning && (
                    <GridContainer>
                        <ItemGrid xs={12} sm={12} md={12}>
                            <Card>
                                <div>
                                    <GridContainer justify="center">
                                        <ItemGrid xs={12} sm={12} md={3}>
                                            <Snackbar
                                                place="tc"
                                                color="warning"
                                                icon={AddPhoto}
                                                message={msgErrorWarning}
                                                open={openErrorWarning}
                                                closeNotification={() => this.closeErrorWarning()}
                                                close
                                            />
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                            </Card>
                        </ItemGrid>
                    </GridContainer>
                )}

            </div>
        )
    }
}

export default UploadPhotoMultiRefactored;



// WEBPACK FOOTER //
// ./src/views/Users/UploadPhotoMultiRefactored.jsx